<template>
  <div class="text-center">
    <audio ref="audioPlayer"
           @timeupdate="updateProgressBar"
           @ended="resetPlayer"
    >
      <source :src="audioSrc"
              type="audio/mpeg"
      >
    </audio>
    <div class="d-flex justify-content-center">
      <div>
        <b-button
          :id="audioVolumeControlId"
          variant="gradient-warning btn-audio volume-btn"
          class="btn-icon"
          style="border-top-right-radius: 0;border-bottom-right-radius: 0;"
        >
          <feather-icon :icon="volume > 0 ? 'Volume2Icon' : 'VolumeXIcon'" />
        </b-button>
        <b-popover
          :target="audioVolumeControlId"
          triggers="click"
          no-fade
          class="custom-popover"
        >
          <vue-slider
            v-model="volume"
            direction="ltr"
            :min-value="0"
            :max-value="100"
            @change="setVolume"
          />
        </b-popover>
      </div>
      <transition name="width">
        <div v-if="isPlaying"
             class="progress-info"
        >
          <div class="progress-bar"
               @click="seek"
          >
            <div class="progress bg-success"
                 :style="{ width: progress + '%' }"
            />
          </div>
        </div>
      </transition>
      <div>
        <b-button
          variant="gradient-warning"
          class="btn-icon btn-audio play-btn"
          style="border-top-right-radius: 0;border-bottom-right-radius: 0;"
          @click.stop="togglePlayback"
        >
          <feather-icon :icon="isPlaying ? 'PauseIcon' : 'PlayIcon'" />
        </b-button>
      </div>
      <div>
        <b-button
          :id="audioSpeedControlId"
          variant="gradient-warning btn-audio speed-btn"
          class="btn-icon"
          style="border-top-left-radius: 0;border-bottom-left-radius: 0;"
        >
          <span class="speed-text">{{ currentSpeedLabel }}</span>
        </b-button>
        <b-popover
          :target="audioSpeedControlId"
          triggers="click"
          placement="top"
          no-fade
          custom-class="speed-popover"
        >
          <template #title>
            <div class="popover-title">
              <feather-icon icon="ZapIcon"
                            size="16"
              />
              Playback Speed
            </div>
          </template>
          <div class="speed-options">
            <b-button
              v-for="speed in speedOptions"
              :key="speed.value"
              :variant="currentSpeed === speed.value ? 'primary' : 'outline-primary'"
              size="sm"
              class="speed-option"
              @click="setSpeed(speed.value)"
            >
              <span class="speed-multiplier">{{ speed.value }}x</span>
              <span class="speed-name">{{ speed.label }}</span>
            </b-button>
          </div>
        </b-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BPopover, VBPopover } from 'bootstrap-vue'
import VueSlider from 'vue-slider-component'

export default {
  components: {
    BButton,
    BPopover,
    VueSlider,
  },
  directives: {
    'b-popover': VBPopover,
  },
  props: {
    audioSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPlaying: false,
      progress: 0,
      volume: 100,
      currentSpeed: 1,
      speedOptions: [
        { value: 1, label: 'Normal' },
        { value: 0.90, label: 'Slow' },
        { value: 0.80, label: 'Slowest' },
      ],
      audioVolumeControlId: Math.random().toString(36).substring(2, 10),
      audioSpeedControlId: Math.random().toString(36).substring(2, 10),
    }
  },
  computed: {
    currentSpeedLabel() {
      const speedOption = this.speedOptions.find(option => option.value === this.currentSpeed)
      return `${speedOption ? speedOption.value : '1'}X`
    },
  },
  methods: {
    play() {
      this.togglePlayback()
    },
    togglePlayback() {
      const audio = this.$refs.audioPlayer
      if (this.isPlaying) {
        this.$emit('onPause', audio)
        audio.pause()
        this.isPlaying = false
      } else {
        this.$emit('onPlay', audio)
        const playPromise = audio.play()
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              this.isPlaying = true
            })
            .catch(error => {
              if (error.name === 'NotAllowedError') {
                // Handle NotAllowedError (typically due to autoplay policy)
                this.$emit('onEnded')
                this.isPlaying = false
                // Optionally: show a UI hint or handle as needed
              } else {
                // Handle or log other errors if needed
                this.$emit('onEnded')
                this.isPlaying = false
              }
            })
        } else {
          this.isPlaying = true
        }
      }
    },
    updateProgressBar() {
      const audio = this.$refs.audioPlayer
      const progress = (audio.currentTime / audio.duration) * 100
      this.progress = progress
    },
    seek(event) {
      const audio = this.$refs.audioPlayer
      const progressBar = event.target
      const rect = progressBar.getBoundingClientRect()
      const clickX = event.clientX - rect.left
      const percentage = (clickX / progressBar.offsetWidth)
      audio.currentTime = audio.duration * percentage
    },
    setVolume() {
      const audio = this.$refs.audioPlayer
      audio.volume = this.volume / 100
    },
    setSpeed(speed) {
      const audio = this.$refs.audioPlayer
      this.currentSpeed = speed
      audio.playbackRate = speed
      this.$nextTick(() => {
        const btn = document.getElementById(this.audioSpeedControlId)
        if (btn) btn.click()
      })
    },
    resetPlayer() {
      this.$emit('onEnded')
      this.progress = 0
      this.isPlaying = false
    },
  },
}
</script>

<style scoped>
.progress-bar {
  background-color: #ddd;
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.progress {
  /* background-color: blue; */
  height: 100%;
}

/* button {
  margin-top: 10px;
} */
.progress-info {
  width: 100px;
  /* margin-top: 22px; */
}

::v-deep .popover-body {
  width: 200px;
}

/* .fade-enter-active, .fade-leave-active {
  transition: opacity 5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} */
.width-enter-active, .width-leave-active {
  transition: width 1s;
}
.width-enter, .width-leave-to {
  width: 0;
}

.play-btn {
  border-radius: 0;
}

.speed-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 140px;
}

.speed-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  transition: all 0.2s ease;
}

.speed-multiplier {
  font-weight: 600;
}

.speed-name {
  font-size: 11px;
  opacity: 0.8;
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .audio-player {
    padding: 16px;
    border-radius: 12px;
  }

  .control-panel {
    gap: 8px;
  }

  .volume-btn {
    display: none;
  }

  .control-btn {
    width: 40px;
    height: 40px;
  }

  .play-btn {
    width: 48px;
    height: 48px;
  }

  .time-display {
    font-size: 11px;
    min-width: 30px;
  }

  .progress-container {
    padding: 0 4px;
  }
}

@media (max-width: 400px) {
  .speed-btn {
    display: none;
  }
}
</style>
